import classNames from 'classnames'
import { useState } from 'react'
import { Version } from 'src/Version'

import { useIdentity, useRealIdentity } from '../adapters/Identity'
import { useUsersList } from '../useUsers'

import { IssuesPicker } from './IssuesPicker'
import { ProjectPicker } from './ProjectPicker'

import './styles.css'

type Props = {
  className?: string
}

export function LeftPane(props: Props) {
  const { className } = props
  const [projectId, setProjectId] = useState<number>()

  return (
    <section className={classNames('left-pane', className)}>
      <IdentityPicker />
      <ProjectPicker onChange={setProjectId} value={projectId} />
      <IssuesPicker projectId={projectId} />

      <Version className="version" />
    </section>
  )
}

function IdentityPicker() {
  const [identity, impersonate] = useIdentity()
  const realMe = useRealIdentity()

  const users = useUsersList()

  if (!realMe) return null

  return (
    <select
      onChange={(event) => {
        if (!users) return
        const targetUser = users.find(
          (user) => String(user.id) === event.target.value,
        )

        impersonate(targetUser || null)
      }}
      value={identity?.id}
    >
      <option value={realMe?.id} key={realMe?.id}>
        {realMe?.name}
      </option>
      <optgroup label="Autres utilisateurs">
        {users?.map((user) => {
          if (user.id === realMe?.id) return null
          return (
            <option value={user.id} key={user.id}>
              {user.name}
            </option>
          )
        })}
      </optgroup>
    </select>
  )
}
